
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 1v15.467c-.94-.284-1.94-.467-3-.467-4.98 0-9 3.35-9 7.5S7.02 31 12 31c4.62 0 8.4-2.917 8.9-6.667h.1V6h8V1H15z"}})])
          )
        }
      }
    